import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';

const FloatingContactUs = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust breakpoint as needed
    };

    // Check initial screen size
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (isMobile) {
    return null; // Don't render on mobile screens
  }

  const containerStyle = {
    position: 'fixed',
    top: '50%',
    right: 0,
    transform: 'translateY(-50%)',
    backgroundColor: '#fff',
    borderRadius: '0 2px 2px 0',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
    padding: '5px',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    maxWidth: '50px', // Restrict maximum width
  };

  const buttonStyle = {
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    padding: '5px',
    borderRadius: '0px',
    cursor: 'pointer',
    fontSize: '14px', // Smaller font for better fit
    fontWeight: 'bold',
    transition: 'background-color 0.3s',
    writingMode: 'vertical-rl', // Vertical text orientation
    textAlign: 'center',
    overflow: 'hidden',
    textDecoration: 'none', // Remove underline for NavLink
  };

  const buttonHoverStyle = {
    backgroundColor: '#0056b3',
  };

  const iconContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'center',
  };

  const iconStyle = {
    color: '#007bff',
    fontSize: '18px', // Adjust size for responsiveness
    textDecoration: 'none',
    transition: 'color 0.3s',
  };

  const iconHoverStyle = {
    color: '#0056b3',
  };

  return (
    <div style={containerStyle}>
      <NavLink
        to="/contact#contactusform"
        style={buttonStyle}
        onMouseOver={(e) => (e.target.style.backgroundColor = buttonHoverStyle.backgroundColor)}
        onMouseOut={(e) => (e.target.style.backgroundColor = buttonStyle.backgroundColor)}
      >
        Contact Us
      </NavLink>
      <div style={iconContainerStyle}>
      <a
          href="https://www.linkedin.com/company/nextech-plm-solutions/"
          target="_blank"
          rel="noopener noreferrer"
          style={iconStyle}
          onMouseOver={(e) => (e.target.style.color = iconHoverStyle.color)}
          onMouseOut={(e) => (e.target.style.color = iconStyle.color)}
        >
          <i className="fab fa-linkedin-in"></i>
        </a>
        <a
          href="https://wa.me/9970166224" // Replace with your WhatsApp number
          target="_blank"
          rel="noopener noreferrer"
          style={iconStyle}
          onMouseOver={(e) => (e.target.style.color = iconHoverStyle.color)}
          onMouseOut={(e) => (e.target.style.color = iconStyle.color)}
        >
          <i className="fab fa-whatsapp"></i>
        </a>
        <a
          href="https://www.facebook.com/share/vNf8TQB9UWD12RVY/?mibextid=qi2Omg"
          target="_blank"
          rel="noopener noreferrer"
          style={iconStyle}
          onMouseOver={(e) => (e.target.style.color = iconHoverStyle.color)}
          onMouseOut={(e) => (e.target.style.color = iconStyle.color)}
        >
          <i className="fab fa-facebook-f"></i>
        </a>
        <a
          href="https://www.instagram.com/nextech_plm_solutions?igsh=MTUwOWtvM3h2cHJrdw=="
          target="_blank"
          rel="noopener noreferrer"
          style={iconStyle}
          onMouseOver={(e) => (e.target.style.color = iconHoverStyle.color)}
          onMouseOut={(e) => (e.target.style.color = iconStyle.color)}
        >
          <i className="fab fa-instagram"></i>
        </a>
       
      </div>
    </div>
  );
};

export default FloatingContactUs;
